export enum RoleCode {
  user = "user",
  seller = "seller",
  seller_external = "seller_external",
  translator = "translator",
  accountant = "accountant",
  warehouser = "warehouser",
  warehouse_manager = "warehouse_manager",
  admin = "admin",
  superadmin = "superadmin",
  factory = "factory",
}
